import { I18n } from 'common/visualizations';

const scope = 'shared.components.schedule_send_report.modal.attachment_section';

export const DEFAULT_ATTACHMENT_CONFIG = {
  value: 'full-report',
  format: 'pdf',
  type: 'full_report',
  name: I18n.t('full_report', { scope })
};

export const ATTACHMENT_ICONS = {
  full_report: 'file_chart',
  table_export: 'table_large'
};

const pdfConfigScope = `${scope}.pdf_configuration`;

export const PDF_CONFIGURATION_PAGE_SIZE = [
  { label: I18n.t('page_size_options.a4', { scope: pdfConfigScope }), value: 'A4' },
  { label: I18n.t('page_size_options.letter', { scope: pdfConfigScope }), value: 'Letter' },
  { label: I18n.t('page_size_options.legal', { scope: pdfConfigScope }), value: 'Legal' }
];

export const PDF_CONFIGURATION_ORIENTATION = [
  { label: I18n.t('orientation_options.portrait', { scope: pdfConfigScope }), value: 'portrait' },
  { label: I18n.t('orientation_options.landscape', { scope: pdfConfigScope }), value: 'landscape' }
];

export const PDF_CONFIGURATION_COLUMN_WIDTH = [
  { label: I18n.t('column_width_options.best_fit', { scope: pdfConfigScope }), value: 'bestfit' },
  { label: I18n.t('column_width_options.inherit', { scope: pdfConfigScope }), value: 'inherit' }
];

export const PDF_CONFIGURATION_TEXT_OVERFLOW = [
  { label: I18n.t('text_overflow_options.word_wrap', { scope: pdfConfigScope }), value: 'linebreak' },
  { label: I18n.t('text_overflow_options.overflow', { scope: pdfConfigScope }), value: 'visible' },
  { label: I18n.t('text_overflow_options.truncate', { scope: pdfConfigScope }), value: 'ellipsize' }
];

export const PDF_CONFIGURATION_PAGE_BREAK = [
  { label: I18n.t('page_break_options.standard', { scope: pdfConfigScope }), value: 'standard' },
  { label: I18n.t('page_break_options.break_on_groups', { scope: pdfConfigScope }), value: 'group' }
];
